import react, { useEffect } from "react";
import { Link } from "react-router-dom";

function DogsAvailable() {
  useEffect(() => {
    document.title = "Available Dogs - High Altitude Labs";

    let e = document.getElementById("canonicallink");
    if (e != null) {
      document.head.removeChild(e);
    }

    let link: HTMLLinkElement = document.createElement("link");

    link.id = "canonicallink";
    link.rel = "canonical";
    link.href = "https://highaltitudelabs.com/dogs/available/";
    link.setAttribute("data-react-helmet", "true");
    document.head.appendChild(link);
  }, []);

  return (
    <div>
      <section className="card">
        <div className="row">
          <div className="col s12">
            <div className="container">
              <div className="row">
                <div className="col s12 m12">
                  <h6>Sorry we don't have available dogs at this time.</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DogsAvailable;
